import { useEffect, useState } from "react";
import { aiStagingApi } from "../../lib/aiStagingApi";
import { Badge } from "../ui/Badge";
import { Button } from "../ui/Button";
import { toast } from "../ui/Toast";
import { mapApiError } from "../ui/StatusMessage";

/** Admin switch: also stage the AI extraction's output as drafts in the review library. Off by default. */
export function AiStagingToggle({ token }: { token: string }) {
  const [enabled, setEnabled] = useState<boolean | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    aiStagingApi.get(token).then((r) => setEnabled(r.enabled)).catch(() => setEnabled(null));
  }, [token]);

  if (enabled === null) return null;

  async function flip() {
    setBusy(true);
    try {
      setEnabled((await aiStagingApi.set(token, !enabled)).enabled);
    } catch (e) {
      toast.error(mapApiError(e).message, { action: { label: "Try again", onClick: () => void flip() } });
    } finally {
      setBusy(false);
    }
  }

  return (
    <section aria-label="AI extraction drafts" className="flex flex-wrap items-center gap-3 rounded-tile border border-border bg-card p-3">
      <span className="text-sm font-semibold text-foreground">Stage AI extraction as drafts</span>
      <Badge variant={enabled ? "success" : "secondary"}>{enabled ? "On" : "Off"}</Badge>
      <span className="min-w-0 flex-1 text-xs text-muted-foreground">New AI notes and quizzes also appear here as drafts for review. Existing flows are unchanged.</span>
      <Button size="sm" variant="outline" loading={busy} loadingText="Saving…" onClick={() => void flip()}>{enabled ? "Turn off" : "Turn on"}</Button>
    </section>
  );
}
